import React from 'react';
import CustomImage from '../../../components/custom-image';

const IronOreSteel = () => {
  return (
    <div className="card">
      <div className="title">
        <div className="icon">
          <CustomImage className="custom-image" imageName="icon-ironore-steel-ved.png" alt="Iron ore steel" maxWidth="90" />
        </div>
        <div className="text">
          <h4>Iron ore &amp; Steel</h4>
        </div>
      </div>
      <div className="middle-text">
        <p>
        One of the largest iron ore
        miners in India 
        </p>
      </div>
      <div className="bottom-text">
        <p className="title-cr">EBITDA (In INR Cr.)</p>
        <p className="green-text"><span>Iron: </span>878</p>
        <p className="green-text"><span>Steel: </span>588</p>
      </div>
    </div>
  );
};

export default IronOreSteel;
